import '@/assets/css/style.css'
import '@/assets/css/main.css'
import '@/assets/css/thirdparty.css'
import '@/assets/css/filepond.css'
import '@/assets/css/popper.css'
import 'flatpickr/dist/flatpickr.min.css'

//Toast/Banner
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Vue FilePond
import "filepond/dist/filepond.min.css"

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/router.js'

// Popper
import Popper from "vue3-popper";

// Reverb/Websockets
import { echoes } from '@/composables/echo/useEchoes.js'

//Userpilot
import { UserpilotService } from '@/models/utils/UserpilotUtils.js'
UserpilotService.initialize();

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.use(Toast); //To set default options pass second param object

app.component("Popper", Popper);

/**
 * Configure the Echo instance for the application.
 */
echoes.configure();

app.mount('#app')
